// Facility Roles
const FACILITY_ROLE_PREFIX = 'FACILITY_ROLE_'
export const FACILITY_ROLE = {
  LIST_REQUEST: `${FACILITY_ROLE_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${FACILITY_ROLE_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${FACILITY_ROLE_PREFIX}LIST_FAILURE`,
  CREATE_REQUEST: `${FACILITY_ROLE_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${FACILITY_ROLE_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${FACILITY_ROLE_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${FACILITY_ROLE_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${FACILITY_ROLE_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${FACILITY_ROLE_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${FACILITY_ROLE_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${FACILITY_ROLE_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${FACILITY_ROLE_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${FACILITY_ROLE_PREFIX}CLEAR_NOTIFY`
}

